import { EnumBase } from 'hay-core-react';
class PesquisaCondicaoDisparoEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.pesquisa.condicaodisparo.sempreenviar',
                'main.pesquisa.condicaodisparo.apenasnaoenviados',
            ],
            'main.pesquisa.condicaodisparo.apenasnaoenviados'
        );
    }
}

const instance = new PesquisaCondicaoDisparoEnum();
export default instance;
